<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    {{ s_insurance_date_higher }}-
    {{ s_insurance_date_lower }}
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">年度</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="term_year_list"
                v-model="s_sports_year"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-1" v-if="true">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">保険開始</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <input
                type="date"
                class="form-control"
                v-model="s_insurance_start_higher"
              />
              <span class="input-group-text">以降</span>
            </div>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <input
                type="date"
                class="form-control"
                v-model="s_insurance_start_lower"
              />
              <span class="input-group-text">以前</span>
            </div>
          </div>
        </div>
        <div class="row mb-1" v-if="true">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">保険終了</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <input
                type="date"
                class="form-control"
                v-model="s_insurance_end_higher"
              />
              <span class="input-group-text">以降</span>
            </div>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <input
                type="date"
                class="form-control"
                v-model="s_insurance_end_lower"
              />
              <span class="input-group-text">以前</span>
            </div>
          </div>
        </div>
        <div class="row mb-1" v-if="false">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">購入期間</p>
          </div>
          <div class="col-7 mb-2">
            <div class="input-group">
              <bs-select
                :options="s_date_month_list"
                v-model="s_sales_date_higher"
                :null-option="false"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">〜</span>
              <bs-select
                :options="s_date_month_list"
                v-model="s_sales_date_lower"
                :null-option="false"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center"></div>
          <div
            class="col text-center"
            v-if="chk_relation_type_editable('insurance/list')"
          >
            <bs-button
              :btnClass="'btn-primary'"
              :disabled="chk_search_btn ? false : 'disabled'"
              @to_click_event="download_insurance()"
              >条件でCSV出力</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'InsuranceListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '保険データCSV出力',
      fromParentBtn: '',
      s_sports_year: '',
      s_sales_date_higher: '',
      s_sales_date_lower: '',
      s_insurance_start_higher: '',
      s_insurance_start_lower: '',
      s_insurance_end_higher: '',
      s_insurance_end_lower: ''
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect
  },
  computed: {
    term_year_list: function () {
      const now = new Date()
      const currentYear = now.getFullYear()
      const years = []
      for (let y = parseInt(currentYear); y >= 2000; y--) {
        years.push({
          key: y,
          label: y + '年度'
        })
      }
      return years
    },
    s_date_month_list: function () {
      const month = []
      for (let m = 1; m <= 12; m++) {
        month.push({
          key: m,
          label: m + '月'
        })
      }
      return month
    },
    chk_search_btn: function () {
      if (
        !this.s_sports_year
        // ||
        // (
        //   !this.s_sales_date_higher ||
        //   !this.s_sales_date_lower
        // )
      ) {
        return false
      }
      return true
    },
    ...mapState({})
  },
  watch: {
    s_term_date_higher: {
      handler(newVal) {
        if (newVal == '') {
          this.s_term_date_lower = ''
        } else if (this.s_term_date_lower || newVal > this.s_term_date_lower) {
          this.s_term_date_lower = newVal
        }
        this.s_term_date_higher = newVal
      }
    }
    // s_term_date_lower: {
    //   handler(newVal) {
    //     if (this.s_term_date_higher || newVal < this.s_term_date_higher) {
    //       this.s_term_date_higher = newVal
    //     }
    //     this.s_term_date_lower = newVal
    //   }
    // }
    // change_login_pass: {
    //   handler(newVal, oldVal){
    //     if(
    //       newVal == '' ||
    //       this.chk_passwd_character(newVal)
    //     ){
    //       this.change_login_pass = newVal
    //     }
    //     else{
    //       this.change_login_pass = oldVal
    //     }
    //   }
    // },
    // confirm_login_pass: {
    //   handler(newVal, oldVal){
    //     if(
    //       newVal == '' ||
    //       this.chk_passwd_character(newVal)
    //     ){
    //       this.confirm_login_pass = newVal
    //     }
    //     else{
    //       this.confirm_login_pass = oldVal
    //     }
    //   }
    // }
  },
  async created() {},
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '保険データ出力ができます。'
  },

  methods: {
    clear() {
      this.s_sports_year = ''
      this.s_sales_date_higher = ''
      this.s_sales_date_lower = ''
      this.s_insurance_start_higher = ''
      this.s_insurance_start_lower = ''
      this.s_insurance_end_higher = ''
      this.s_insurance_end_lower = ''
      // const params = { ...this.sprm }
      // if (typeof params === 'object') {
      //   Object.keys(params).forEach(sprm_key => {
      //     params[sprm_key] = ''
      //   })
      // }
      // this.sprm = params
      // this.$store.dispatch('setSearchParam', {
      //   data: params,
      //   target: 'license_cd'
      // })
    },
    async download_insurance() {
      const params = {}
      // params['id'] = 1176
      params['stat'] = [1]
      params['sports_year'] = this.s_sports_year

      if (this.s_insurance_start_higher) {
        params['start_higher'] = this.s_insurance_start_higher + ' 00:00:00'
      }
      if (this.s_insurance_start_lower) {
        params['start_lower'] = this.s_insurance_start_lower + ' 23:59:59'
      }
      if (this.s_insurance_end_higher) {
        params['end_higher'] = this.s_insurance_end_higher + ' 00:00:00'
      }
      if (this.s_insurance_end_lower) {
        params['end_lower'] = this.s_insurance_end_lower + ' 23:59:59'
      }

      if (this.s_sales_date_higher) {
        params['sales_date_higher'] = this.s_sales_date_higher
      }
      if (this.s_sales_date_lower) {
        params['sales_date_lower'] = this.s_sales_date_lower
      }

      await this.basicPosts_S(
        config.BASE_API_URL + '/member_insurance/output_csv',
        params
      )
        .then(async response => {
          console.log('download_insurance response', response)
          window.open(
            config.BASE_API_URL + '/member/download?file=' + response.data.body,
            '_blank'
          )
        })
        .catch(async err => {
          console.log(err)
          alert('error')
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  }
}
</script>
